(function () {
  'use strict';

  Controller.$inject = ['SensorService', '$rootScope', '$state', 'AppUtils', '$element', '$timeout', '$window'];

  window.angular.module('app').component('panicButtonDataDisplay', {
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      options: '<',
      disableClick: '<',
      onLoadContent: '=',
      maxHeight: '<',
      disableSpinner: '<',
      filterByZone: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm panic-button-panel" ng-class="{\'panic-button-panel--critical\': ctrl.viewMode === \'alert\'}" ng-if="!ctrl.onlyContent"><header class="panel-heading"><h2 class="nowrap"><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.content"><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-if="ctrl.hasImages" ng-click="ctrl.setViewMode(\'image\')" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'entities._all.image\'}"><input type="radio"> <i class="fas fa-fw fa-image"></i></label> <label ng-click="ctrl.setViewMode(\'alert\')" ng-class="{active: ctrl.viewMode === \'alert\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.alert\'}"><input type="radio"> <i class="fas fa-fw fa-exclamation-triangle"></i></label> <label ng-click="ctrl.setViewMode(\'raw\')" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-fw fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content" class="panic-button-display" ng-class="{ \'panic-button-display--with-image\': ctrl.viewMode === \'image\', \'panic-button-display--alert\': ctrl.viewMode === \'alert\' }"><div ng-if="ctrl.viewMode === \'image\'" class="panic-button-display__image-mode"><div class="panic-button-display__media" ng-style="ctrl.imageMediaStyle"><a class="panic-button-display__media-link" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence ng-if="ctrl.imagesSrc.length" images-src="ctrl.imagesSrc" max-height="ctrl.imageMaxHeight || ctrl.maxHeight" on-load-content="ctrl.onLoadImage" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" field="\'image\'"></image-sequence></a></div><div class="alert alert-danger panic-button-summary" role="alert" aria-live="assertive"><div class="panic-button-summary__header"><div class="panic-button-summary__badge"><i class="fas fa-exclamation-triangle"></i> <span>{{ctrl.alertBadge}}</span></div></div><div class="panic-button-summary__title" ng-if="ctrl.alertTitle">{{ctrl.alertTitle}}</div><div class="panic-button-summary__title" ng-if="!ctrl.alertTitle" translate="{{ctrl.alertTitleKey}}" translate-values="ctrl.alertTitleValues"></div><div class="panic-button-summary__message" ng-if="ctrl.alertMessage">{{ctrl.alertMessage}}</div></div></div><div ng-if="ctrl.viewMode === \'alert\'" class="panic-button-emergency" role="alert" aria-live="assertive"><div class="panic-button-emergency__signal" aria-hidden="true"><div class="panic-button-emergency__signal-ring"><div class="panic-button-emergency__signal-core"><i class="fas fa-exclamation-triangle"></i></div></div></div><div class="panic-button-emergency__badge">{{ctrl.alertBadge}}</div><div class="panic-button-emergency__title" ng-if="ctrl.alertTitle">{{ctrl.alertTitle}}</div><div class="panic-button-emergency__title" ng-if="!ctrl.alertTitle" translate="{{ctrl.alertTitleKey}}" translate-values="ctrl.alertTitleValues"></div><div class="panic-button-emergency__message" ng-if="ctrl.alertMessage">{{ctrl.alertMessage}}</div></div><pre ng-if="ctrl.viewMode === \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="ctrl.data && !ctrl.data.content"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content panic-button-only-content"><div ng-if="ctrl.content" class="panic-button-display" ng-class="{ \'panic-button-display--with-image\': ctrl.viewMode === \'image\', \'panic-button-display--alert\': ctrl.viewMode === \'alert\' }"><div ng-if="ctrl.viewMode === \'image\'" class="panic-button-display__image-mode panic-button-display__image-mode--overlay"><div class="panic-button-display__media" ng-style="ctrl.imageMediaStyle"><a class="panic-button-display__media-link" ng-class="{\'cursor-pointer\': !ctrl.disableClick}" ng-click="ctrl.expand()" target="_blank"><image-sequence ng-if="ctrl.imagesSrc.length" images-src="ctrl.imagesSrc" max-height="ctrl.imageMaxHeight || ctrl.maxHeight" on-load-content="ctrl.onLoadImage" dimensions="ctrl.dimensions" sensor="ctrl.sensor" data="ctrl.data" field="\'image\'"></image-sequence><div class="alert alert-danger panic-button-summary panic-button-summary--overlay" role="alert" aria-live="assertive"><div class="panic-button-summary__header"><div class="panic-button-summary__badge"><i class="fas fa-exclamation-triangle"></i> <span>{{ctrl.alertBadge}}</span></div></div><div class="panic-button-summary__title" ng-if="ctrl.alertTitle">{{ctrl.alertTitle}}</div><div class="panic-button-summary__title" ng-if="!ctrl.alertTitle" translate="{{ctrl.alertTitleKey}}" translate-values="ctrl.alertTitleValues"></div><div class="panic-button-summary__message" ng-if="ctrl.alertMessage">{{ctrl.alertMessage}}</div></div></a></div></div><div ng-if="ctrl.viewMode === \'alert\'" class="panic-button-emergency" role="alert" aria-live="assertive"><div class="panic-button-emergency__signal" aria-hidden="true"><div class="panic-button-emergency__signal-ring"><div class="panic-button-emergency__signal-core"><i class="fas fa-exclamation-triangle"></i></div></div></div><div class="panic-button-emergency__badge">{{ctrl.alertBadge}}</div><div class="panic-button-emergency__title" ng-if="ctrl.alertTitle">{{ctrl.alertTitle}}</div><div class="panic-button-emergency__title" ng-if="!ctrl.alertTitle" translate="{{ctrl.alertTitleKey}}" translate-values="ctrl.alertTitleValues"></div><div class="panic-button-emergency__message" ng-if="ctrl.alertMessage">{{ctrl.alertMessage}}</div></div><pre ng-if="ctrl.viewMode === \'raw\'">{{ctrl.content | json}}</pre></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div>',
  });

  function Controller(SensorService, $root, $state, utils, $element, $timeout, $window) {
    const angular = window.angular;
    let vm = this;
    vm.viewMode = 'raw';
    vm.imagesSrc = [];
    vm.hasImages = false;
    vm.imageMediaStyle = {};
    vm.setViewMode = setViewMode;

    vm.$onInit = function () {
      angular.element($window).on('resize', scheduleImageLayoutUpdate);

      vm.state = $state.get().reduce((filtered, current) => {
        const name = current.name;
        const component = current.component;
        if (name.includes('dataDisplay') && component === 'monitoringDataDisplay') {
          filtered.push(current);
        }
        return filtered;
      }, [])[0];

      vm.dimensions = {};
      vm.onLoadImage = onLoadImage;
      vm.expand = expand;
      updateDisplayData();
    };

    vm.$onDestroy = function () {
      angular.element($window).off('resize', scheduleImageLayoutUpdate);
      if (vm.imageLayoutPromise) {
        $timeout.cancel(vm.imageLayoutPromise);
      }
    };

    vm.$onChanges = function () {
      vm.disableSpinner = typeof vm.disableSpinner === 'boolean' ? vm.disableSpinner : false;
      updateDisplayData();
    };

    function getImages() {
      if (vm.content) {
        vm.images = vm.content.files ? vm.content.files.image : null;
        if (vm.images) {
          utils.sortArrayByField(vm.images, 'originalFilename');
        }
      } else {
        vm.images = null;
      }
    }

    function onLoadImage(err, images) {
      if (vm.onLoadContent) {
        vm.onLoadContent(err, images);
      }

      if (!err) {
        scheduleImageLayoutUpdate();
      }
    }

    function updateDisplayData() {
      vm.content = vm.data?.content;
      vm.imagesSrc = [];
      vm.alertBadge = 'SOS';
      vm.alertTitle = '';
      vm.alertTitleKey = 'entities.sensortype.__types.PanicButton';
      vm.alertTitleValues = {};
      vm.alertMessage = '';
      vm.hasImages = false;

      if (!vm.data || !vm.content) {
        return;
      }

      getImages();
      vm.hasImages = Array.isArray(vm.images) && vm.images.length > 0;
      vm.imagesSrc = vm.hasImages
        ? vm.images.map((image) => SensorService.getImageUrl(vm.sensor.id, image))
        : [];

      vm.alertBadge = vm.content.buttonCode || 'SOS';
      vm.alertTitle = vm.content.title || '';
      vm.alertTitleKey = vm.alertTitle ? '' : getDefaultAlertTitleKey();
      vm.alertTitleValues = vm.content.buttonCode ? { buttonCode: vm.content.buttonCode } : {};
      vm.alertMessage = vm.content.text || vm.content.description || '';

      if (!vm.hasImages) {
        onLoadImage(null, []);
      }

      vm.viewMode = vm.hasImages ? 'image' : 'alert';
      scheduleImageLayoutUpdate();
    }

    function getDefaultAlertTitleKey() {
      if (vm.content?.buttonCode) {
        return 'general.panicButtonPressed';
      }

      return 'general.panicButtonActivated';
    }

    function expand() {
      if (vm.disableClick) {
        return;
      }

      const dataId = vm.data.referenceId || vm.data.id;
      window.open(
        $state.href(
          vm.state,
          {
            projectId: $root.projectId,
            assetId: vm.sensor.assetId,
            sensorId: vm.sensor.id,
            dataId: utils.isDate(dataId) ? dataId.getTime() : dataId,
            zoneFilter: true,
          },
          '_blank'
        )
      );
    }

    function setViewMode(mode) {
      vm.viewMode = mode;
      scheduleImageLayoutUpdate();
    }

    function scheduleImageLayoutUpdate() {
      if (vm.imageLayoutPromise) {
        $timeout.cancel(vm.imageLayoutPromise);
      }

      vm.imageLayoutPromise = $timeout(updateImageLayout, 0);
    }

    function updateImageLayout() {
      if (!vm.hasImages || vm.viewMode !== 'image') {
        vm.imageMaxHeight = null;
        vm.imageMediaStyle = {};
        return;
      }

      const host = $element[0];
      const viewport = host.querySelector('.rt-content');
      const imageMode = host.querySelector('.panic-button-display__image-mode');

      if (!viewport || !imageMode) {
        return;
      }

      const availableWidth = imageMode.clientWidth;
      let availableHeight = vm.onlyContent ? getAvailableHeight(host, viewport) : viewport.clientHeight;

      if (!vm.onlyContent) {
        const summary = host.querySelector('.panic-button-summary');
        if (!summary) {
          return;
        }

        availableHeight -= summary.offsetHeight + 8;
      }

      if (availableWidth <= 0 || availableHeight <= 0) {
        vm.imageMaxHeight = null;
        vm.imageMediaStyle = {};
        return;
      }

      const targetRatio = 16 / 9;
      let imageFrameWidth = Math.floor(availableWidth);
      let imageFrameHeight = Math.floor(imageFrameWidth / targetRatio);

      if (imageFrameHeight > availableHeight) {
        imageFrameHeight = Math.floor(availableHeight);
        imageFrameWidth = Math.floor(imageFrameHeight * targetRatio);
      }

      vm.imageMaxHeight = imageFrameHeight;
      vm.imageMediaStyle = {
        width: `${imageFrameWidth}px`,
        height: `${imageFrameHeight}px`,
        maxWidth: '100%',
      };
    }

    function getAvailableHeight(host, viewport) {
      const candidates = [viewport, host];
      let current = host.parentElement;

      while (current && candidates.length < 8) {
        candidates.push(current);
        current = current.parentElement;
      }

      for (const element of candidates) {
        if (!element || !element.getBoundingClientRect) {
          continue;
        }

        const rect = element.getBoundingClientRect();
        if (rect.height > 120) {
          return rect.height;
        }
      }

      return Math.floor($window.innerHeight * 0.6);
    }
  }
})();
